<div class="account-card font-size-12">
  <div *ngIf="member$ | async as member">
    <div class="mb-4">
      <label class="mb-2 text-primary fw-bold">{{ 'account.details.dob' | translate }}</label>
      <div class="d-flex bg-primary-alternate p-2 m-0 rounded d-flex align-items-center flex-row">
        <span class="icon material-icons" aria-hidden="true">date_range</span>
        <span class="ms-2 text-primary">{{ member.DOB | date: 'MMM d, yyy' }}</span>
      </div>
    </div>
    <div class="mb-4">
      <label class="mb-2 text-primary fw-bold">{{ 'account.details.contact.no' | translate }}</label>
      <div class="d-flex bg-primary-alternate p-2 m-0 rounded d-flex align-items-center flex-row">
        <span class="icon material-icons" aria-hidden="true">phone</span>
        <span class="ms-2 text-primary">{{ member.HomeNumber }}</span>
      </div>
    </div>
    <div class="mb-0">
      <label class="mb-2 text-primary fw-bold personal-info">{{ 'account.details.email' | translate }}</label>
      <div class="d-flex bg-primary-alternate p-2 m-0 rounded d-flex align-items-center flex-row">
        <span class="icon material-icons" aria-hidden="true">email</span>
        <span class="ms-2 text-primary">{{ member.EmailAddress1 }}</span>
      </div>
    </div>
  </div>
</div>
<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
